// Cached Elements
var header = jQuery('.header-wrapper');
var headerSpacer = jQuery('.header-spacer');
var scrollPrompt = jQuery('.scroll-prompt');
var footer = jQuery('footer.main');

import Rellax from 'rellax';
import { CountUp } from 'countup.js';
var Cookies = require('cookies-js')

// #region Document/Window Events

function jCheck()
{
    return document.documentElement.clientWidth <= 1440 && document.documentElement.clientWidth > 1280;
}

// Page Load
document.addEventListener('DOMContentLoaded', function()
{
    // Get the text size cookie, if set
    var textCookie = Cookies.get('tollers_text_size');

    if( jCheck() )
    {
        switch( textCookie )
        {
            case 'small': jQuery('html,body').css('font-size', '8px'); break;
            case 'medium': jQuery('html,body').css('font-size', '12px'); break;
            case 'large': jQuery('html,body').css('font-size', '16px'); break;
        }
    }
    else
    {
        switch( textCookie )
        {
            case 'small': jQuery('html,body').css('font-size', '12px'); break;
            case 'medium': jQuery('html,body').css('font-size', '16px'); break;
            case 'large': jQuery('html,body').css('font-size', '20px'); break;
        }
    }

    setTimeout( function()
    {
        if( window.scrollY > 0 )
        {
            // Create a spacer for the sticky header
            headerSpacer.css('height', (header.outerHeight() + 27) + 'px');
        }
        else
        {
            // Create a spacer for the sticky header
            headerSpacer.css('height', header.outerHeight() + 'px');
        }

        // Perform scroll animations
        scrollInEffects();

        setTimeout( function()
        {
            // Check if we need to jump to an enquiry form
            if( window.location.href.indexOf( '?enquiry=1' ) > -1 )
            {
                // Ensure we have an enquiry form to jump to
                if( jQuery('.enquiry-form').length > 0 )
                {
                    // Scroll to the enquiry form
                    jQuery('html, body').animate({ scrollTop: jQuery('.enquiry-form').first().offset().top - header.outerHeight() - 45 }, 500);
                }
            }
        }, 1000 );

    }, 100 );

    // Set the text for "blank" select options in enquiry forms
    jQuery('.enquiry-form span.title select option').first().text('Your Title');
    jQuery('.enquiry-form span.type select option').first().text('Type of Claim');

    // Hide file uploads with custom buttons next to them (using JS so non-JS users can still upload)
    jQuery('a.file-upload').parent().find('input[type="file"]').hide();

    // Start Rellax
    if( document.documentElement.clientWidth > 1440 )
    {
        var rellax = new Rellax('.header-image img', {
            speed: 25
        });
    }
    else if( document.documentElement.clientWidth > 1300 )
    {
        var rellax = new Rellax('.header-image img', {
            speed: 10
        });
    }

    var rellax = new Rellax('.header-image-home img', {
        speed: 10
    });

    // Set the form element tab indexes
    tollersSetTabIndexes();

    const grid = document.querySelector('.location-grid');
    if(grid){
        const items = grid.children.length;

        if (items === 1) grid.classList.add('full-width');
        else if (items === 2) grid.classList.add('two-columns');
        else if (items === 3) grid.classList.add('three-columns');
        else if (items === 4) grid.classList.add('four-columns');
        else if (items === 5) grid.classList.add('split-3-2');
        else if (items === 6) grid.classList.add('six-columns');
        else if (items === 7) grid.classList.add('split-4-3');
        else if (items >= 8) grid.classList.add('eight-columns');
    }

});

// Window Scroll
jQuery(window).on('scroll', function()
{
    // Perform scroll animations
    scrollInEffects();

    // Toggles the sticky header as required
    toggleStickyHeader();

    if( scrollPrompt.length > 0 )
    {
        // Hide the scroll prompt at the bottom of the page
        if( scrollPrompt.offset().top >= footer.offset().top && !scrollPrompt.hasClass('back-to-top') )
        {
            scrollPrompt.addClass('back-to-top');
        }
        else if( scrollPrompt.offset().top < footer.offset().top && scrollPrompt.hasClass('back-to-top') )
        {
            scrollPrompt.removeClass('back-to-top');
        }
    }
});

// Window Resize
jQuery(window).resize(function ()
{
    // Fade in elements
    scrollInEffects();
});

// #endregion

// #region Animation

function toggleStickyHeader()
{
    if(window.pageYOffset > 0)
    {
        if(!header.hasClass('stuck'))
        {
            header.addClass('stuck');
            headerSpacer.css('height', header.outerHeight() + 'px');
        }
    }
    else
    {
        if(header.hasClass('stuck'))
        {
            header.removeClass('stuck');

            setTimeout(function() {
                headerSpacer.css('height', header.outerHeight() + 'px')
            }, 20);
        }
    }
}

// Scroll Animations

var fadeinpos = 75;
var scrollInEffectsOnScrollUp = false;

function scrollInEffects()
{
    jQuery('.fadein:not(.fadedin)').each(function ()
    {
        var bottomOfMarker = jQuery(this).offset().top + fadeinpos;
        var bottomOfObject = jQuery(this).offset().top + jQuery(this).outerHeight();
        var bottomOfWindow = jQuery(window).scrollTop() + jQuery(window).height();
        var topOfWindow = jQuery(window).scrollTop();

        if ((bottomOfWindow > bottomOfMarker || bottomOfWindow > bottomOfObject) && bottomOfObject > topOfWindow)
        {
            jQuery(this).queue(function (next)
            {
                jQuery(this).addClass('fadedin');

                if(jQuery(this).hasClass('count-up'))
                {
                    jQuery(this).find('[data-countup]').each(function(index, item)
                    {
                        var defaults = {
                            startVal: 0,
                            decimalPlaces: 0,
                            duration: 2,
                            endVal: item.getAttribute('data-countup'),
                        };

                        var countUp = new CountUp(item, defaults.endVal, defaults);
                        countUp.start();
                    });
                    jQuery(this).removeClass('count-me');
                }
                next();
            });
        }
        else if (!scrollInEffectsOnScrollUp && bottomOfObject < topOfWindow)
        {
            jQuery(this).addClass('fadedin');
        }
    });

    jQuery('.zoomin:not(.zoomedin)').each(function ()
    {
        var bottomOfMarker = jQuery(this).offset().top + fadeinpos;
        var bottomOfObject = jQuery(this).offset().top + jQuery(this).outerHeight();
        var bottomOfWindow = jQuery(window).scrollTop() + jQuery(window).height();
        var topOfWindow = jQuery(window).scrollTop();

        if ((bottomOfWindow > bottomOfMarker || bottomOfWindow > bottomOfObject) && bottomOfObject > topOfWindow)
        {
            jQuery(this).queue(function (next) {
                jQuery(this).addClass('zoomedin');
                next();
            });
        }
        else if (!scrollInEffectsOnScrollUp && bottomOfObject < topOfWindow)
        {
            jQuery(this).addClass('zoomedin');
        }
    });
}

// #endregion

// #region Controls

// Scroll Prompts
scrollPrompt.on('click', function()
{
    if( jQuery(this).hasClass('back-to-top') )
    {
        // Scroll back to the header
        jQuery('html, body').animate({ scrollTop: 0 }, 500);
    }
});

// Toggle Panel
jQuery('.toggle-panel a').on('click', function(e)
{
    // Toggle the content expansion
    jQuery(this).toggleClass('expanded');
    jQuery(this).parent().next('div').slideToggle(200);

    // Prevent link navigation
    e.preventDefault();
});

// Accordions
jQuery('ul.accordion > li > a').on('click', function(e)
{
    // Toggle the content expansion
    jQuery(this).toggleClass('expanded');
    jQuery(this).next('div').slideToggle(200);

    // Prevent link navigation
    e.preventDefault();
});

jQuery('a.file-upload').on('click', function(e)
{
    // Trigger a file open dialog
    jQuery(this).parent().find('input[type="file"]').click();

    // Prevent link navigation
    e.preventDefault();
});

jQuery('a.fbp').on('click', function(e)
{
    jQuery.fancybox.open({
        src  : jQuery(this).prop('href'),
        type : 'iframe',
	    smallBtn : true,
    });

    // Prevent link navigation
    e.preventDefault();
});

// Cache all grid steps on the page
var gridSteps = jQuery('.process-grid .step');
var gridInner = jQuery('.process-grid .inner');

// Process Grids
jQuery('.process-grid .step > div > a').on('mouseenter', function(e)
{
    // Clear the current grid step
    gridSteps.removeClass('current');

    // Set the clicked step as the current one
    jQuery(this).parents('.step').addClass('current');

    // Get the number of this step
    var clickedStepNumber = parseInt(jQuery(this).data('number'));

    // Find the corresponding step data in the global step data
    var currentStep = window.processSteps.filter( function(step)
    {
        // Ensure the step number matches the current step
        return parseInt(step.number) === clickedStepNumber;
    })[0];

    // Update the displayed content
    gridInner.children('.pre-title').text('Step ' + currentStep.number);
    gridInner.children('.title').text(currentStep.title);
    gridInner.children('.content').html(currentStep.content);

    // Prevent navigation
    e.preventDefault();
});

// Cache all calculator links and the content area
var calculatorLinks = jQuery('.claim-calculator .labels a');
var calculatorContent = jQuery('.claim-calculator .claim-content');
var figurePoints = jQuery('.figure-points .point');

// Claim Calculator
jQuery('.claim-calculator .labels a').on('mouseenter', function()
{
    // Clear the current calculator selection
    calculatorLinks.removeClass('current');

    // Set the clicked link as the current one
    jQuery(this).addClass('current');

    // Get the index of this injury type
    var clickedTypeIndex = parseInt(jQuery(this).data('index'));
    var injuryLocation = jQuery(this).data('location');

    // Hide all figure points and display the one for this injury
    figurePoints.removeClass('visible');
    jQuery('.figure-points .point[data-location="' + injuryLocation + '"]').addClass('visible');

    // Find the corresponding injury type data in the global injury type data
    var currentType = window.claimCalculatorTypes.filter( function(type)
    {
        // Ensure the step number matches the current step
        return parseInt(type.index) === clickedTypeIndex;
    })[0];

    // Delete all existing details
    calculatorContent.children('.detail').remove();

    // Update the displayed title
    calculatorContent.children('.title').text(currentType.name);

    jQuery(currentType.severities).each(function(index, severity)
    {
        var minComp = parseFloat(severity.min_compensation);
        var compensation = '';

        if( minComp === 0 )
        {
            compensation = 'Up to £' + parseFloat(severity.max_compensation).toLocaleString();
        }
        else compensation = '£' + parseFloat(severity.min_compensation).toLocaleString() + ' - ' + '£' + parseFloat(severity.max_compensation).toLocaleString();

        // Create a new element to add to the content
        var newDetail = jQuery('<div class="detail"><div class="type">' + severity.severity + '</div><div>' + compensation + '</div></div>');
        calculatorContent.append(newDetail);
    });
});

jQuery('.claim-calculator .labels a').on('click', function(e)
{
    // Prevent navigation
    e.preventDefault();
});

// Tab Controls
jQuery('.tab-control .tab-items > div > a').on('mouseenter', function(e)
{
    // Get the current tab control instance
    var tabControl = jQuery(this).parents('.tab-control');

    // Clear the current selection
    tabControl.find('.tabs > div').hide();
    tabControl.find('.tab-items > div').removeClass('current');

    // Get the index of the clicked tab
    var tabIndex = parseInt( jQuery(this).parent().data('tab') );

    // Find the tab with the matching index
    var tab = tabControl.find('.tabs > div[data-tab="' + tabIndex + '"]');

    // Select the new tab
    jQuery(this).parent().addClass('current');
    tab.show();

    // Prevent navigation
    e.preventDefault();
})

// Text Sizer
jQuery('.text-sizer').on('click', '.sizer-small', function(e)
{
    if( jCheck() )
    {
        jQuery('html,body').css('font-size', '8px');
    }
    else
    {
        jQuery('html,body').css('font-size', '12px');
    }

    Cookies.set('tollers_text_size', 'small');
    e.preventDefault();
});

jQuery('.text-sizer').on('click', '.sizer-medium', function(e)
{
    if( jCheck() )
    {
        jQuery('html,body').css('font-size', '12px');
    }
    else
    {
        jQuery('html,body').css('font-size', '16px');
    }

    Cookies.set('tollers_text_size', 'medium');
    e.preventDefault();
});

jQuery('.text-sizer').on('click', '.sizer-large', function(e)
{
    if( jCheck() )
    {
        jQuery('html,body').css('font-size', '16px');
    }
    else
    {
        jQuery('html,body').css('font-size', '20px');
    }

    Cookies.set('tollers_text_size', 'large');
    e.preventDefault();
});

// Responsive Menu
jQuery('.menu-toggle').on('click', function(e)
{
    jQuery('.small-menu-wrapper').toggleClass('visible');

    // Prevent navigation
    e.preventDefault();
});

jQuery('.small-menu-wrapper').on('click', function(e)
{
    jQuery(this).removeClass('visible');
});

jQuery('.small-menu').on('click', function(e)
{
    // Prevent propagation to the parent (small-menu-wrapper) so the menu does not close
    e.stopPropagation();
});

// Search Toggle
jQuery('.search-toggle').on('click', function(e)
{
    jQuery('.desktop-search').slideToggle(200);

    // Prevent navigation
    e.preventDefault();
});

// Header Phone Modal
(function() {
    const phoneModalToggles = document.querySelectorAll('.phone-modal-toggle');

    if (!phoneModalToggles.length) {
        return;
    }

    phoneModalToggles.forEach(function(toggle) {
        toggle.addEventListener('click', function(event) {
            event.preventDefault();
            jQuery.fancybox.open({
                src: '#phone-office-modal',
                type: 'inline',
                smallBtn: true,
                toolbar: false,
            });
        });
    });
})();

// Back to Top Links (Shortcode)
jQuery('.back-top a').on('click', function(e)
{
    // Scroll to the top of the page
    jQuery('html, body').animate({ scrollTop: 0 }, 500);

    // Prevent navigation
    e.preventDefault();
});

// Create DOM templates for the different kinds of search result
var pagesResultTemplate = jQuery('<div class="result"><div class="content"><div class="title"><a href=""></a></div><div class="excerpt"></div></div></div>');
var staffResultTemplate = jQuery('<div class="result"><div class="image"><a href=""></a></div><div class="content"><div class="title"><a href=""></a></div><div class="position"></div></div></div>');

// Search (AJAX)
var searchTimeout = null;

jQuery('.search input').on('input', function()
{
    // Clear the timeout so the previous search request does not occur yet if the user is still typing
    clearTimeout(searchTimeout);

    var searchQuery = jQuery(this).val();

    // Check if any search term has actually been entered
    if( searchQuery === '' )
    {
        jQuery('.search-results').hide();
        jQuery('.search-empty').text('Start typing to see results here.');
        jQuery('.search-empty').show();
    }
    else
    {
        searchTimeout = setTimeout( function()
        {
            // Make the request and mount the resulting data
            jQuery.ajax({
                method: 'POST',
                url: tollers_ajax.ajax_url,
                data: {
                    action: 'tollers_get_search_results',
                    nonce: tollers_ajax.nonce,
                    query: searchQuery
                }
            })
            .done(function (response)
            {
                // Clear existing results
                jQuery('.search-results .result').remove();

                // console.log(response);

                if(response.success)
                {
                    // Determine whether any results were returned
                    if(response.data.pages.length === 0 && response.data.staff.length === 0)
                    {
                        // No results were found
                        jQuery('.search-results').hide();
                        jQuery('.search-empty').text('No results were found for your search.');
                        jQuery('.search-empty').show();
                    }
                    else
                    {
                        // We found results
                        jQuery('.search-results').css('display', 'flex');
                        jQuery('.search-empty').hide();

                        var pageResults = response.data.pages;

                        if(pageResults.length > 0)
                        {
                            for (let i = 0; i < pageResults.length; i++)
                            {
                                var resultData = pageResults[i];

                                // Clone the result template to populate with data
                                var result = pagesResultTemplate.clone();

                                // Populate the data
                                result.find('.title a').text(resultData.title);
                                result.find('.title a').attr('href', resultData.link);
                                result.find('.excerpt').html(resultData.excerpt);

                                // Add the result to the page
                                jQuery('.search-results .pages').append(result);
                            }
                        }

                        var staffResults = response.data.staff;

                        if(staffResults.length > 0)
                        {
                            for (let i = 0; i < staffResults.length; i++)
                            {
                                var resultData = staffResults[i];

                                // Clone the result template to populate with data
                                var result = staffResultTemplate.clone();

                                // Populate the data
                                result.find('.title a').text(resultData.title);
                                result.find('.title a').attr('href', resultData.link);
                                result.find('.position').text(resultData.position);
                                result.find('.image a').append(jQuery('<img>', { src: resultData.image, alt: resultData.title }));
                                result.find('.image a').attr('href', resultData.link);

                                // Add the result to the page
                                jQuery('.search-results .staff').append(result);
                            }
                        }
                    }
                }
                else
                {
                    console.error('There was an error retrieving search results.');
                    jQuery('.search-results').hide();
                    jQuery('.search-empty').text('No results were found for your search.');
                    jQuery('.search-empty').show();
                }
            })
            .fail( function(response)
            {
                console.log(response);
            });
        }, 500);
    }
});

// Postcode Lookup (AJAX)
jQuery('a.postcode-lookup').on('click', function(e)
{
    var houseNo  = jQuery(this).parent().find('input[name="house-no"]').val();
    var postcode = jQuery(this).parent().find('input[name="postcode"]').val();

    if( typeof houseNo !== 'undefined' && houseNo.trim() !== '' && typeof postcode !== 'undefined' && postcode.trim() !== '' )
    {
        // Make the request and mount the resulting data
        jQuery.ajax({
            method: 'POST',
            url: tollers_ajax.ajax_url,
            data: {
                action: 'tollers_postcode_lookup',
                nonce: tollers_ajax.nonce,
                postcode: postcode
            }
        })
        .done(function (response)
        {
            // console.log(response);

            if(response.success)
            {
                // Load in the address data
                if( typeof( response.data.addressLine1 ) !== 'undefined' )
                {
                    jQuery('.address-1 input').val(houseNo + ' ' + response.data.addressLine1);
                }

                if( typeof( response.data.town ) !== 'undefined' )
                {
                    jQuery('.town input').val(response.data.town);
                }

                if( typeof( response.data.county ) !== 'undefined' )
                {
                    jQuery('.county input').val(response.data.county);
                }

                // Disable the button to prevent abuse
                jQuery('a.postcode-lookup').attr('data-disabled', 'true');
            }
            else
            {
                if( typeof(response.data.alert) !== 'undefined' ) alert(response.data.alert);
                console.error('There was an error performing the postcode lookup.');
            }
        })
        .fail( function(response)
        {
            console.log(response);
        });
    }
    else
    {
        alert( 'Please enter a house number and postcode.' );
    }

    // Prevent navigation
    e.preventDefault();
});

// Load More Posts (AJAX)
jQuery('a.load-more').on('click', function(e)
{
    // Retrieve the specified global variable with the query args
    var queryVars = window[jQuery(this).data('var')];
    var selector  = jQuery(this).data('selector');
    var me        = this;
    var meText    = this.innerText;

    if( typeof( queryVars ) !== 'undefined' )
    {
        // Make the request and mount the resulting data
        jQuery.ajax({
            method: 'POST',
            url: tollers_ajax.ajax_url,
            data:
            {
                action: 'tollers_load_more_posts',
                nonce: tollers_ajax.nonce,
                query: queryVars.query,
                page: queryVars.current_page
            },
            beforeSend: function()
            {
                jQuery(me).addClass('busy');
                jQuery(me).text('');
            }
        })
        .done(function (response)
        {
            if(response)
            {
                var jResponse = jQuery(response);

                // Load the received HTML into the document
                jResponse.hide().appendTo(jQuery(selector));

                // Update heights
                jQuery('[data-mh]').matchHeight();

            
                jQuery('[data-mh="article-title"]').matchHeight();
                // Track the current page
                queryVars.current_page++;

                if( queryVars.current_page >= queryVars.max_page )
                {
                    // Fade out the button then remove it from the document, as no more pages may be loaded
                    jQuery(me).fadeOut(200, function() { jQuery(this).remove() } );
                }

                // Display the new elements
                jResponse.fadeIn(100);
            }
        })
        .fail( function(response)
        {
            console.log(response);
        })
        .always( function()
        {
            jQuery(me).removeClass('busy');
            jQuery(me).text(meText);
        });
    }

    // Prevent navigation
    e.preventDefault();
});

// #endregion

// #region Popup Functionality

// Modal popup handling
jQuery(document).on('click', '.popup', function(e) {
    // Get the popup ID from the data attribute
    var popupId = jQuery(this).data('popup');
    
    if (popupId) {
        // Find the popup regardless of nesting - directly select by ID
        var $popup = jQuery('#' + popupId);
        
        if ($popup.length > 0) {
            // Store original parent if not already stored
            if (!$popup.data('original-parent')) {
                $popup.data('original-parent', $popup.parent());
            }
            
            // Move to body to ensure proper stacking
            $popup.appendTo('body');
            
            // Add class to body to prevent scrolling
            jQuery('body').addClass('has-popup');
            
            // Show the popup by adding the visible class
            $popup.addClass('visible');
            
            // Add a click event to close the popup when clicking outside of popup content
            jQuery(document).on('click.popup', function(event) {
                if (!jQuery(event.target).closest('.popup-content').length && 
                    !jQuery(event.target).hasClass('popup') && 
                    jQuery(event.target).closest('.popup.visible').length) {
                    closePopup($popup);
                }
            });
            
            // Add close button functionality
            $popup.find('.close-popup').on('click', function() {
                closePopup($popup);
            });
            
            // Prevent default action if it's a link
            e.preventDefault();
        }
    }
});

// Function to close popup and clean up
function closePopup($popup) {
    $popup.removeClass('visible');
    jQuery('body').removeClass('has-popup');
    
    // Return to original parent if we have that data
    if ($popup.data('original-parent')) {
        $popup.appendTo($popup.data('original-parent'));
    }
    
    jQuery(document).off('click.popup');
}

// Close popup when Escape key is pressed
jQuery(document).keyup(function(e) {
    if (e.key === "Escape") {
        var $visiblePopup = jQuery('.popup.visible');
        if ($visiblePopup.length) {
            closePopup($visiblePopup);
        }
    }
});

// Adjusts form tab indexes to allow tabbing horizontally between columns
function tollersSetTabIndexes()
{
    // Find each row on the page
    jQuery('.quform-element-row').each(function( rowIndex, row ) {

        // Retrieve all columns in this row
        var $columns  = jQuery(row).children('.quform-element-column');

        // This is where we will start our tabindex
        var baseIndex = 10 * ( rowIndex + 1);
        var n         = $columns.length;

        $columns.each( function( colIndex, col ) {

            // Iterate through all fields in the column
            jQuery(col).find('input, select').each( function( fieldIndex, field ) {

                field.tabIndex = baseIndex + colIndex + ( fieldIndex * n );

            });

        });

    });
}

// Avant Garde
(function(d) {
    var config = {
      kitId: 'cvb0ywj',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);


var formInputForm = document.querySelector(".quform-field-3_8");
if (formInputForm) {
    formInputForm.tabIndex = 30;
}
